<div class="recommended-campaigns-container" *ngIf="campaignMembers && campaignMembers.length > 0">
  <h3 class="recommended-campaign-title">
    {{ "shared.labels.recommendedCampaigns" | translate }}
  </h3>

  <div class="nonSlide" fxLayout="row wrap">
    <ng-template [ngIf]="!slideStart" *ngFor="let campaign of campaignMembers">
      <div class="recommended-campaign-item no-slide"  fxLayout="column" *ngIf="!campaign.isGroup">
        <a [routerLink]="['/etkinlik', campaign.id, region, lang]">
          <img [src]="getExternalImage(campaign.imageUrl)" alt="Campaign Image" />
          <h3>{{ campaign.name }}</h3>
        </a>
      </div>
      <div class="recommended-campaign-item no-slide"  fxLayout="column" *ngIf="campaign.isGroup">
        <a [href]="getGuideUrl(campaign.alias)">
          <img [src]="getExternalImage(campaign.imageUrl)" alt="Campaign Image" />
          <h3>{{ campaign.name }}</h3>
        </a>
      </div>
    </ng-template>
  </div>

  <ng-template [ngIf]="slideStart">
    <div class="swiper-wrapper" fxLayout="row wrap">
      <swiper
        class="my-swiper"
        [loop]="true"
        [spaceBetween]="20"
        [breakpoints]="breakpoints"
        [loopAdditionalSlides]="2"
        [centeredSlides]="true"
        [autoplay]="true"
      >
        <ng-template *ngFor="let campaign of campaignMembers" swiperSlide>
          <div class="recommended-campaign-item" fxLayout="column" *ngIf="campaign.isGroup">
            <a [href]="getGuideUrl(campaign.alias)">
              <img [src]="getExternalImage(campaign.imageUrl)" alt="Campaign Image" />
              <h3>{{ campaign.name }}</h3>
            </a>
          </div>
          <div class="recommended-campaign-item" fxLayout="column" *ngIf="!campaign.isGroup">
            <a [routerLink]="['/etkinlik', campaign.id, region, lang]">
              <img [src]="getExternalImage(campaign.imageUrl)" alt="Campaign Image" />
              <h3>{{ campaign.name }}</h3>
            </a>
          </div>
        </ng-template>
      </swiper>
      <div>
        <button class="btn-next" (click)="swipeNext()">
          <mat-icon>keyboard_arrow_right</mat-icon>
        </button>
      </div>
      <div>
        <button class="btn-prev" (click)="swipePrev()">
          <mat-icon>keyboard_arrow_left</mat-icon>
        </button>
      </div>
    </div>
  </ng-template>

  <div class="button-actions text-center" *ngIf="slideStart">
    <a [href]="allRecommendCampaigns" mat-stroked-button color="primary" class="see-more-btn">
      {{ "shared.labels.seeAllCampaigns" | translate }}
    </a>
  </div>
</div>
